import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useLanguage } from "../../context/LanguageContext";

const MTBanner = () => {
  const { language, translations } = useLanguage();

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: { xs: "60vh", sm: "135vh", md: "140vh" },
        backgroundImage: "url(https://res.cloudinary.com/dk24unkwu/image/upload/v1753695247/mtBanner_iapknf.png)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
        position: "relative",
        color: "#fff",
        py: { xs: 12, sm: 14, md: 16 },
        px: { xs: 2, sm: 4, md: 6 },
        "@media (max-width:300px)": {
          minHeight: "40vh",
        },
        "@media (min-width:301px) and (max-width:500px)": {
          minHeight: "57vh",
       
        },
      }}
    >
      {/* Optional Overlay */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          zIndex: 1,
        }}
      />

      {/* Responsive Content Box */}
      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          width: "100%",
          maxWidth: "1200px",
          textAlign: "center",
          mx: "auto",
        }}
      >
        <Typography
          variant="h2"
          fontWeight={700}
          sx={{
            fontSize: {
              xs: "2rem",
              sm: "2.5rem",
              md: "3.5rem",
              lg: "4rem",
            },
          }}
        >
          MetaTrader 5
        </Typography>

        <Typography
          sx={{
            mt: 2,
            fontSize: { xs: "0.875rem", sm: "1.15rem", md: "1.25rem" },
            color: "rgba(255, 255, 255, 0.8)",
            maxWidth: "600px",
            mx: "auto",
            fontWeight: 400,
            lineHeight: 1.6,
          }}
        >
          Trade CFDs with BBCorp on the MetaTrader 5 app.
        </Typography>

        {/* Buttons */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "row", // ✅ Always row
            justifyContent: "center",
            alignItems: "center",
            // flexWrap : "wrap", // ✅ Wraps on very small screens if needed
            gap: 2,
            mt: 4,
            px: { xs: 1, md: 4 },
            width: "100%",
          }}
        >
          {/* Google Play */}
          <Button
            component="a"
            href="https://play.google.com/store/apps/details?id=net.metaquotes.metatrader5&hl=en_IN"
            target="_blank"
            rel="noopener noreferrer"
            disableRipple
            sx={{
              background: "#fff",
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              px: 2,
              py: 1,
              width: 160, // ✅ Fixed width for all screens
              height: 56, // ✅ Consistent height
              borderRadius: 2,
              minWidth: "unset", // removes MUI's default button minWidth
              "@media (max-width:600px)": {
                display: "none",
              },
            }}
          >
            <img
              src="/Images/transPlay.png"
              alt="Google Play"
              style={{ width: "22px", height: "22px" }}
            />
            <Box textAlign="left">
              <Typography
                sx={{
                  color: "rgb(62, 68, 71)",
                  fontSize: 10,
                  fontWeight: 500,
                  display: { xs: "none", sm: "none", md: "block" },
                }}
              >
                {translations[language]?.footerButton2title}
              </Typography>
              <Typography
                sx={{
                  color: "#000",
                  fontSize: 15,
                  fontWeight: 600,
                }}
              >
                {translations[language]?.footerButtonName}
              </Typography>
            </Box>
          </Button>

          {/* Apple Store */}
          <Button
            component="a"
            href="https://apps.apple.com/us/app/metatrader-5/id413251709"
            target="_blank"
            rel="noopener noreferrer"
            disableRipple
            sx={{
              background: "#fff",
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              px: 2,
              py: 1,
              width: 160, // ✅ Fixed width
              height: 56, // ✅ Fixed height
              borderRadius: 2,
              minWidth: "unset",
              "@media (max-width:600px)": {
                display: "none",
              },
            }}
          >
            <img
              src="/Images/apple.png"
              alt="App Store"
              style={{ width: "30px", height: "30px" }}
            />
            <Box textAlign="left">
              <Typography
                sx={{
                  color: "rgb(62, 68, 71)",
                  fontSize: 10,
                  fontWeight: 500,
                  display: { xs: "none", sm: "none", md: "block" },
                }}
              >
                {translations[language]?.footerButton2title}
              </Typography>
              <Typography
                sx={{
                  color: "#000",
                  fontSize: 15,
                  fontWeight: 600,
                }}
              >
                {translations[language]?.footerButton2Name}
              </Typography>
            </Box>
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default MTBanner;
